import * as React from 'react';
export const IcArmed = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M18.61 6.15c-.26-.31-.62-.5-1.01-.54-1.72-.18-3.4-.68-4.95-1.46a1.432 1.432 0 00-1.28 0c-1.54.78-3.21 1.28-4.92 1.46-.39.04-.76.22-1.03.51-.27.29-.43.68-.44 1.09v4C4.98 16.6 10.25 20 12 20s7.02-3.4 7.02-8.79v-4c0-.39-.16-.77-.42-1.05l.01-.01z'
      fill='currentColor'
    />
  </svg>
);
